export default __webpack_public_path__ + "static/media/solar_bell-outline.31b6b6ff.svg";